import { CSSProperties } from 'react';

import classNames from 'classnames';

import useDeviceType from '../../providers/DeviceType/hooks';
import ComponentType from '../../types/Component';

import styles from './styles.module.scss';

type ContainerType = {
	size?: 'small' | 's-medium' | 'medium' | 'default';
	className?: string;
	style?: CSSProperties;
};

const Container: ComponentType<ContainerType> = ({
	children,
	className,
	style,
	size = 'default',
}) => {
	const { isDesktop } = useDeviceType();

	return (
		<div
			style={style}
			className={classNames([
				styles.container,
				isDesktop && styles.isDesktop,
				className,
				size === 'small' && styles.small,
				size === 's-medium' && styles.sMedium,
				size === 'medium' && styles.medium,
			])}>
			{children}
		</div>
	);
};

export default Container;
